import { Component } from 'react';
import moment from 'moment';
import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row, Col, CardFooter
} from 'reactstrap';
import api from '../api/dataSource';
import { Loading } from '../components/Loading';
import AwesomeSlider from "react-awesome-slider";
import AwsSliderStyles from 'react-awesome-slider/src/styles'

const Slider = () => (
  <AwesomeSlider style={{'width': '600px'}}>
    <div data-src="img/slider/slider1.jpg" />
    <div data-src="img/slider/slider2.jpg" />
    <div data-src="img/slider/slider3.jpg" />
  </AwesomeSlider>
)

class Empresas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titulo: 'Lista de campeonatos',
      esLista: true,
      empresas: [],
      productos: [],
      currentCampeonato: 0,
      showEmpresas: false,
      modal: false,
      currentEmpresa: '',
      loading: false,
      loadingProductos: false,
      currentNumber: 0,
      currentSlider: [],
      loadingProd: false,
      currentObs: ''
    };
    this.getEquipos = this.getEquipos.bind(this);
    this.mostrarProductos = this.mostrarProductos.bind(this);
    this.sendMessage = this.sendMessage.bind(this)
    this.redirigirAsociados = this.redirigirAsociados.bind(this)
    this.redirigirComunicacion = this.redirigirComunicacion.bind(this)
    this.getImagenes = this.getImagenes.bind(this)
  }

  getEquipos() {
    this.setState({ loading: true })
    api.getCampeonato(`api/obtener_empresas_pagina`).then((resp) => {
      this.setState({ empresas: resp })
    }).catch(error => {
      alert("Error al intentar buscar las empresas")
    }).finally(() => {
      this.setState({ loading: false })
    })
  }

  mostrarProductos(x) {
    this.setState({ loadingProductos: true, modal: true, currentEmpresa: '', currentNumber: '', productos: [] })
    api.getCampeonato(`api/obtener_productos_pagina/${x.id}`).then((resp) => {
      this.setState({ productos: resp })
      this.setState({ currentEmpresa: x.nombre })
      this.setState({ currentNumber: x.contacto })
    }).catch(error => {
      alert("Error al buscar")
    }).finally(() => {
      this.setState({ loadingProductos: false })
    })
  }

  salirModal() {
    this.setState({ modal: false, currentSlider: [], currentObs: '' })
  }

  componentDidMount(){
    this.getEquipos()
  }

  sendMessage() {
    let a = document.createElement("a")
    a.href = `https://wa.me/591${this.state.currentNumber}`
    a.target = "_blank"
    a.click()
    a.remove()
  }

  redirigirAsociados() {
    let a = document.createElement("a")
    a.href = `http://crdascz.com/crdasczX/asociados/`
    a.click()
    a.remove()
  }

  redirigirComunicacion() {
    const numeros = ['62135657', '69050866']
    const i = Math.round(Math.random())
    let a = document.createElement("a")
    a.href = `https://wa.me/591${numeros[i]}`
    a.target = "_blank"
    a.click()
    a.remove()
  }

  getImagenes(ide, obs) {
    this.setState({ loading: true })
    this.setState({ loadingProd: true, currentObs: obs, currentSlider: [] })
    api.getCampeonato(`api/obtener_multimedia_producto/${ide}`).then((resp) => {
      this.setState({currentSlider: resp})
    }).catch(error => {
      alert("Error al buscar las imagenes")
    }).finally(() => {
      this.setState({ loading: false })
      this.setState({ loadingProd: false })
    })
  }

  render () {
    return (
      <div className="container" style={{paddingTop: '100px'}}>
        <div className="row">
          <div className="col-12">
            <Card>
              <CardBody className="mt-4">
                <CardTitle style={{'display': 'flex', 'justifyContent': 'space-between'}}>
                  <h1><i className="fa fa-industry" /> Lista de Empresas</h1>
                  <div>
                    <Button color="info" onClick={() => this.redirigirComunicacion()}>
                      <i className="fa fa-whatsapp" />&nbsp;&nbsp;
                      Ayuda Soporte CRDA SC
                    </Button>
                    <Button color="warning" onClick={() => this.redirigirAsociados()}>
                      <i className="fa fa-users" />&nbsp;&nbsp;
                      Asociados Validar Beneficiario
                    </Button>
                  </div>
                </CardTitle>
              </CardBody>
            </Card>
          </div>
        </div>
        <br />
        <div className="row d-flex justify-content-center">
          {/*<div className="col-sm-8 offset-sm-2" style={{textAlign: '-webkit-center'}}>*/}
          <div>
            <Slider />
          </div>
        </div>
        <br/>
        <br/>
        <div className="row">
          <div className="col-12">
            {
              this.state.loading
              ? <Loading />
              : (
                <Card>
                  <CardBody className="text-center mt-4">
                    <CardTitle>
                    <Row style={{textAlign: 'center'}}>
                      {
                        this.state.empresas.map(x => (
                          <Col sm="12" md="3" key={x.id}>
                            <Card onClick={() => this.mostrarProductos (x)} style={{cursor: 'pointer', height: '200px', marginBottom: '15px'}}>
                              <img className="centro" style={{ width: '100%', height: '150px' }} src={`data:image/jpeg;base64,${x.foto}`} alt="Logo" />
                              <CardBody style={{padding: '0px'}}>
                                <CardText>{x.nombre}</CardText>
                              </CardBody>
                            </Card>
                          </Col>
                        ))
                      }
                    </Row>
                    </CardTitle>
                  </CardBody>
                </Card>
              )
            }
          </div>
        </div>
        <br /><br />
        <Modal size="xl" isOpen={this.state.modal}>
          <ModalHeader>
            <h3>Productos de {this.state.currentEmpresa}</h3>
          </ModalHeader>
          <ModalBody>
              {
                this.state.loadingProductos
                ? (
                    <div className="row">
                      <div className="col-md-12">
                        <h3 align="center">Buscando ...</h3>
                      </div>
                    </div>
                  )
                : (
                  <div className="row">
                    <div className="col-sm-12 col-md-5">
                      <Table bordered>
                        <thead>
                        <tr>
                          <th width="10">#</th>
                          <th width="50">Producto</th>
                          <th width="30">Descuento</th>
                          <th width="10">Ver</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                          this.state.productos.map(x => (
                            <tr key={x.id}>
                              <th scope="row">{x.id}</th>
                              <td style={{textAlign: 'left'}}>{x.producto.nombre}</td>
                              <td>{x.descuento} %</td>
                              <td>
                                <span onClick={() => this.getImagenes(x.idProducto, x.producto.detalle)} style={{'cursor': 'pointer'}}>
                                  <i className="fa fa-eye" />
                                </span>
                              </td>
                            </tr>
                          ))
                        }
                        </tbody>
                      </Table>
                    </div>
                    <div className="col-sm-12 col-md-7">
                      <Card style={{'maxHeight': 'calc(100vh - 250px)', 'overflow': 'auto'}}>
                        <CardBody className="text-center mt-4">
                            <div className="row">
                              <div className="col-md-12">
                                <h5>
                                  {this.state.currentObs}
                                </h5>
                              </div>
                              <div className="col-md-12">
                                {this.state.loadingProd && (<h3 align="center">Buscando imagenes ...</h3>)}
                                {!this.state.loadingProd && this.state.currentSlider.length === 0 && (<h3 align="center">No cuenta con imágenes</h3>)}
                              </div>
                            </div>
                          {
                            this.state.currentSlider.map((x) => (
                              <div style={{'padding': '10px'}}>
                                <img className="centro2" style={{ width: '90%' }} src={`data:image/jpeg;base64,${x.foto}`} alt="Logo" />
                              </div>
                            ))
                          }
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                )
              }
            </ModalBody>
          <ModalFooter>
            {
              !!this.state.currentNumber && (
                <Button color="success" onClick={() => this.sendMessage()}>
                  <i className="fa fa-whatsapp" />&nbsp;&nbsp;
                  Contacto
                </Button>
              )
            }
            <Button color="secondary" onClick={() => this.salirModal()}>Salir</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default Empresas;
